const safetyItems = [
  {
    icon: 'ri-shield-check-line',
    title: 'SSL Protected',
    description: 'All connections to the VigorBuy Spreadsheet resource are secured with industry-standard encryption.',
  },
  {
    icon: 'ri-lock-line',
    title: 'Secure Payments',
    description: 'When you shop through verified VigorBuy Spreadsheet sellers, your payment information stays protected.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Manual QC Verification',
    description: 'Every seller in our VigorBuy Spreadsheet is manually reviewed and QC-verified before listing.',
  },
  {
    icon: 'ri-fingerprint-line',
    title: 'Privacy Protection',
    description: 'Your browsing and shopping data is never shared. We respect your privacy at every step.',
  },
];

export default function SafetySection() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Shop <span className="text-accent-500">Safely</span> with Confidence
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            We take safety seriously. Every VigorBuy Spreadsheet resource is verified to ensure a secure shopping experience.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {safetyItems.map((item) => (
            <div key={item.title} className="bg-background-50 rounded-xl border border-background-200/70 p-6 text-center hover:border-accent-200 transition-colors">
              <span className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}